import React, { Component } from 'react';
import PageHeading from '../../components/PageHeading';
import { LazyPage } from '../../components/LazyPage';

export default class InvoicesPage extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <LazyPage>
        <PageHeading>Выплаты</PageHeading>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. At eius fugiat libero vel voluptate? Atque autem consequuntur debitis dignissimos dolore ducimus eligendi est, maiores, molestias odio perspiciatis quae quibusdam unde.</p>
      </LazyPage>
    );
  }
}
